// react-redux imports
import { useSelector } from "react-redux";
import { RootState } from "app/store";

import FlexColumn from "common/components/styled-components/FlexColumn";
import StackedBar from "./StackedBar";
import SectionDescription from "./styled-components/SectionDescription";

interface TransportProps {
  averageFootprint: number;
  userFootprint: number;
  averageSectorFootprint: number;
  userSectorFootprint: number;
}

function Transport({
  averageFootprint,
  userFootprint,
  averageSectorFootprint,
  userSectorFootprint,
}: TransportProps) {
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  return (
    <FlexColumn gap={upDesktopScreen ? 20 : 24}>
      <StackedBar
        title="Movilidad"
        averageColor="#a6be0a"
        averageValue={averageSectorFootprint}
        userColor="#dde393"
        userValue={userSectorFootprint}
        total={Math.max(averageFootprint, userFootprint)}
      />
      <SectionDescription>
        Para disminuir tu huella en el ámbito de la movilidad es conveniente que
        programes tus rutas, tengas en cuenta la calificación energética de tus
        vehiculos y optar por los que emplean biocombustibles o eléctricos,
        entre otras medidas.
      </SectionDescription>
    </FlexColumn>
  );
}

export default Transport;
